import Vue from 'vue'
import Vuex from 'vuex'
import token from './auth/token'
import settlementData from './settlement/settlementData'
import outletMenuRequestList from './outlet/outletMenuRequestList'
import accountantForSettlement from './settlement/accountantForSettlement'
import { authentication } from './auth/auth'
import outlet from './outlet/outlet'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    authentication,
    token,
    outlet,
    settlementData,
    outletMenuRequestList,
    accountantForSettlement
  }
})
